import { Visualize3dObject, getComponent } from '../../models/visualize3d-object';
import { OnObject3dInit } from '../../view-interactions/object-3d-events';
import { Injectable } from '@angular/core';
import { AmbientLightComponent } from '../ambient-light-component';
import { AmbientLight as ThreeJsAmbientLight, Object3D } from 'three';

@Injectable({
  providedIn: 'root',
})
export class AmbientLightComponentHandler implements OnObject3dInit {
  initialize(object3d: Object3D, v3dObject: Visualize3dObject): void {
    const component = getComponent<AmbientLightComponent>(v3dObject, 'AmbientLight');
    if (!component) {
      return;
    }
    const light = new ThreeJsAmbientLight(component.color, component.intensity);
    object3d.add(light);
  }
}
